import {
  MailOutlined,
  BuildOutlined,
  UserOutlined,
  TeamOutlined,
  TrophyOutlined,
  CalendarOutlined,
  FieldTimeOutlined,
} from '@ant-design/icons';
import { PRIMARY_COLOR } from '@/utils/color';

export const Collection = {
  USER: 'User',
  APP: 'App',
  HISTORY: 'History',
  TOKEN: 'Token',
  CROSS_PROMOTION: 'CrossPromotion',
};

export const Role = {
  admin: 'admin',
  member: 'member',
  cs: 'cs',
};

const UserIcon = <UserOutlined style={{ fontSize: '250%', color: PRIMARY_COLOR }} />;
const GameIcon = <BuildOutlined style={{ fontSize: '250%', color: PRIMARY_COLOR }} />;
const MailIcon = <MailOutlined style={{ fontSize: '250%', color: PRIMARY_COLOR }} />;
const LeaderboardIcon = <TrophyOutlined style={{ fontSize: '250%', color: PRIMARY_COLOR }} />;
const TeamIcon = <TeamOutlined style={{ fontSize: '250%', color: PRIMARY_COLOR }} />;
const EventIcon = <CalendarOutlined style={{ fontSize: '250%', color: PRIMARY_COLOR }} />;
const TimeIcon = <FieldTimeOutlined style={{ fontSize: '250%', color: PRIMARY_COLOR }} />;

export const HistoryType = {
  CreateApp: {
    name: 'Create New Game',
    icon: GameIcon,
  },
  CreateShortLiveToken: {
    name: 'Create Short Live Token',
    icon: TimeIcon,
  },
  DeleteApp: {
    name: 'Delete Game',
    icon: GameIcon,
  },
  UpdateApp: {
    name: 'Update Game Info',
    icon: GameIcon,
  },
  UpdateUser: {
    name: 'Update User Info',
    icon: UserIcon,
  },
  SSCreateLeaderboard: {
    name: 'SS: Create Leaderboard',
    icon: LeaderboardIcon,
  },
  SSCreateMailTemplate: {
    name: 'SS: Create Mail Template',
    icon: MailIcon,
  },
  SSCreateMail: {
    name: 'SS: Send Mail',
    icon: MailIcon,
  },
  SSDeleteLeaderboard: {
    name: 'SS: Delete Leaderboard',
    icon: LeaderboardIcon,
  },
  SSDeleteMailTemplate: {
    name: 'SS: Delete Mail Template',
    icon: MailIcon,
  },
  SSResetLeaderboard: {
    name: 'SS: Reset Seasonal Leaderboard',
    icon: LeaderboardIcon,
  },
  SSUpdateGuildSetting: {
    name: 'SS: Update Team Settings',
    icon: TeamIcon,
  },
  SSUpdateEventSetting: {
    name: 'SS: Update Event Settings',
    icon: EventIcon,
  },
  SSUpdateLeaderboard: {
    name: 'SS: Update Leaderboard',
    icon: LeaderboardIcon,
  },
  SSUpdateMailTemplate: {
    name: 'SS: Update Mail Template',
    icon: MailIcon,
  },
  SSUpdateUser: {
    name: 'SS: Update User',
    icon: UserIcon,
  },
  GEUpdateEvent: {
    name: 'GE: Update',
    icon: EventIcon,
  },
  // Cross Promotion
  CPCreateCreative: {
    name: 'Cross Promotion: Create Creative',
    icon: GameIcon,
  },
  CPCreateConfig: {
    name: 'Cross Promotion: Create Config',
    icon: GameIcon,
  },
  CPUpdateCreative: {
    name: 'Cross Promotion: Update Creative',
    icon: GameIcon,
  },
  CPUpdateConfig: {
    name: 'Cross Promotion: Update Config',
    icon: GameIcon,
  },
  CPDeleteCreative: {
    name: 'Cross Promotion: Delete Creative',
    icon: GameIcon,
  },
  CPDeleteConfig: {
    name: 'Cross Promotion: Delete Config',
    icon: GameIcon,
  },
};
